<template>
    <div class="line-c">
        <div class="line-title">
            <slot name="title">
                <span :style="{color: activeColor}" class="active">会员</span>线路系统
            </slot>
        </div>

        <slot></slot>
    </div>
</template>

<script>
  export default {
    name: "index",
    props: {
      list: {
        type: Array,
        default () {
          return [
            {
              title: '线路1',
              v: 46,
              selected: true
            },
            {
              title: '线路2',
              v: 46
            },
            {
              title: '线路3',
              v: 46
            },
            {
              title: '线路4',
              v: 46
            },
            {
              title: '线路5',
              v: 46
            },
            {
              title: '线路6',
              v: 46
            },
            {
              title: '线路7',
              v: 46
            },
          ];
        }
      },
      activeColor: {
        type: String,
        default: '#E64520'
      }
    }
  }
</script>

<style scoped lang="stylus">
    .line-c
        font-size 18px
        margin-top 30px
        padding-top 20px
        background-color rgba(255, 255, 255, 0.2)
        .line-title
            width 170px
            height 40px
            box-sizing border-box
            font-weight 500
            line-height 40px
            padding-left 23px
            background-color #fff
            border-top-right-radius 30px
            border-bottom-right-radius 30px
        .active{
            color #E64520
        }
</style>


// WEBPACK FOOTER //
// src/pages/line/components/line-conponent/index.vue